var map = {
	"./aiJobs.js": "3f2f",
	"./aiModels.js": "9b23",
	"./auditLogs.js": "a4b6",
	"./auth.js": "6bf2",
	"./detectionSets.js": "8cf5",
	"./detections.js": "4008",
	"./index.js": "dde5",
	"./jsonSchemas.js": "0037",
	"./labelSetTags.js": "349a",
	"./labelSets.js": "6aae",
	"./languages.js": "ea3b",
	"./notifications.js": "4eb0",
	"./projectTags.js": "647d",
	"./projectUsers.js": "4fb3",
	"./projects.js": "3e57",
	"./roles.js": "6198",
	"./samPredictionsService.js": "6c8c",
	"./sampleLabelSets.js": "9ed9",
	"./sampleSets.js": "5cd9",
	"./samples.js": "bd5f",
	"./segmentationInterface.js": "b656",
	"./tags.js": "9a3f",
	"./testEndpoint.js": "4cc5",
	"./timeLogs.js": "878e",
	"./translations.js": "e6ca",
	"./users.js": "5b34"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "85d1";